import { render, staticRenderFns } from "./Event_Center.vue?vue&type=template&id=511319a5&scoped=true&"
import script from "./Event_Center.vue?vue&type=script&lang=js&"
export * from "./Event_Center.vue?vue&type=script&lang=js&"
import style0 from "./Event_Center.vue?vue&type=style&index=0&id=511319a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511319a5",
  null
  
)

export default component.exports